document.addEventListener('DOMContentLoaded', function () {
  const cta = document.querySelector('.js-product-form-submit-btn');
  if (!cta) return;

  document.querySelectorAll('[data-add-btn]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      cta.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function(){ cta.click(); }, 300);
    });
  });
});


window.addEventListener("scroll", function () {
  const btn = document.querySelector(".product-form__buttons");
  const half_OffTop = btn.offsetTop / 2;

  const btnOffsetTop = btn.offsetTop + half_OffTop - 200;

  if (!btn) return; // safety

  if (window.scrollY > btnOffsetTop) {
    btn.classList.add("active");
  } else {
    btn.classList.remove("active");
  }
});

//Sticky
const mainCTA = document.querySelector('.template-product .product-btn-atc');
const stickyAtc = document.getElementById('sticky-mobile-atc');
const stickyBtn = stickyAtc?.querySelector('.sticky-atc-btn');

if (!stickyAtc) {
  console.warn("CTA or sticky ATC not found");
}

// Show on load
stickyAtc.style.display = "block";

// Track if CTA is visible
let ctaVisible = false;

// Observer to detect CTA visibility
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      ctaVisible = entry.isIntersecting;

      // If CTA becomes visible -> hide sticky
      if (ctaVisible) {
        stickyAtc.style.display = "none";
      }
    });
  },
  { threshold: 1.0 }
);

observer.observe(mainCTA);

window.addEventListener("scroll", () => {
  const ctaTop = mainCTA.offsetTop;

  // CONDITION TO SHOW:
  // 1. CTA not visible
  // 2. You are ABOVE the CTA
  if (!ctaVisible && window.scrollY < ctaTop) {
    stickyAtc.style.display = "block";
  } else {
    stickyAtc.style.display = "none";
  }
});

// Click triggers main CTA
stickyBtn?.addEventListener("click", () => {
  mainCTA?.click();
  mainCTA?.scrollIntoView({ behavior: "smooth" });
});


/* ============================================================
   1) LISTEN FOR THEME VARIANT CHANGE
============================================================ */
/* ============================================================
   0) SAFE INSTANT DESKTOP SWATCH HIGHLIGHT
   (No document click — only inside desktop variant radios)
============================================================ */
document.querySelectorAll('sht-variant-radios[data-section-type="desktop"] .product-option__label').forEach(picker => {

  picker.addEventListener("click", function (e) {
   
    const radio = e.target.closest('.product-option__value').querySelector(".js-variant-radio-item");
    if (!radio) return;

    const wrapper = radio.closest(".js-variant-option-value");
    if (!wrapper) return;

    const fieldset = wrapper.closest("fieldset");
    if (!fieldset) return;
 
    // Remove old selected state
    fieldset.querySelectorAll(".js-variant-option-value")
      .forEach(el => el.classList.remove("is-selected"));

    // Add new selected instantly
    wrapper.classList.add("is-selected");
  });

});

/* ============================================================
   0) INSTANT DESKTOP SWATCH HIGHLIGHT (corrected selector)
============================================================ */
document.querySelectorAll('sht-variant-radios[data-section$="-desktop"]').forEach(picker => {

  picker.addEventListener("change", function (e) {
    const radio = e.target.closest(".js-variant-radio-item");
    if (!radio) return;

    const wrapper = radio.closest(".js-variant-option-value");
    if (!wrapper) return;

    const fieldset = wrapper.closest("fieldset");
    if (!fieldset) return;

    // fast pre-highlight
    fieldset.querySelectorAll(".js-variant-option-value")
      .forEach(el => el.classList.remove("is-selected"));

    wrapper.classList.add("is-selected");
  });

});


/* ============================================================
   1) LISTEN FOR THEME VARIANT CHANGE
============================================================ */
// document.addEventListener("variant:changed", function (e) {
//   const sectionId = e.detail.sectionId;
//   const variant = e.detail.variant;
//   if (!sectionId) return;

//   // Let Shopify update DOM first
//   requestAnimationFrame(() => {
//     requestAnimationFrame(() => {
//       syncRadios(sectionId, variant);
//       mirrorToDesktop(sectionId);
//       mirrorToMobile(sectionId);
//       handleSoldoutState(sectionId, !variant?.available);
//     });
//   });

//   // Update ONLY mobile slider
//   if (window.innerWidth <= 768) {
//     hideMobileSlider(sectionId); // <-- prevents flicker
//     setTimeout(() => {
//       reinitMobileSlick(sectionId);
//       showMobileSlider(sectionId);
//     }, 200);
//   }
// });

document.addEventListener("variant:changed", function (e) {
  const sectionId = e.detail.sectionId;
  const variant = e.detail.variant;
  if (!sectionId || !variant) return;

  // Allow Shopify to update DOM
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      syncRadios(sectionId, variant);
      mirrorToDesktop(sectionId);
      mirrorToMobile(sectionId);
      handleSoldoutState(sectionId, !variant.available);

      // Mobile slider update (NO reinit)
      if (window.innerWidth <= 768) {
        updateMobileSlickSlide(sectionId, variant);
      }
    });
  });
});


function updateMobileSlickSlide(sectionId, variant) {
  if (!variant.featured_media) return;

  const mediaId = variant.featured_media.id;

  // Target the slider
  const $slider = $(`[data-section="${sectionId}"] .product-slideshow__items`);

  if (!$slider.length || !$slider.hasClass("slick-initialized")) {
    console.warn("⚠ Slick not initialized yet.");
    return;
  }

  // Find slide index
  const slide = $slider.find(`[data-media-id="${mediaId}"]`).closest(".slick-slide");
  const index = slide.data("slick-index");

  // Go to that slide (NO flicker)
  if (index !== undefined) {
    $slider.slick("slickGoTo", index);
  }
}



/* ============================================================
   2) MOBILE SLICK REINIT (NO FLICKER)
============================================================ */
function hideMobileSlider(sectionId) {
  const wrap = document.querySelector(
    `[data-section="${sectionId}"] .product-slideshow__items`
  );
  if (wrap) wrap.style.opacity = "0";
}

function showMobileSlider(sectionId) {
  const wrap = document.querySelector(
    `[data-section="${sectionId}"] .product-slideshow__items`
  );
  if (wrap) wrap.style.opacity = "1";
}

function reinitMobileSlick(sectionId) {
  if (window.innerWidth > 768) return; // mobile only

  const sliderContainer = document.querySelector(
    `[data-section="${sectionId}"] .product-slideshow__items`
  );

  if (!sliderContainer) {
    console.warn("⚠ Mobile slider container not found");
    return;
  }

  const $slider = $(sliderContainer);

  /* ------------------------------------------
     1) Freeze height to prevent flicker/jump
  -------------------------------------------*/
  const freezeHeight = sliderContainer.offsetHeight;
  sliderContainer.style.minHeight = freezeHeight + "px";
  sliderContainer.style.opacity = "0"; // hide swap

  /* ------------------------------------------
     2) Destroy old slick if it exists
  -------------------------------------------*/
  if ($slider.hasClass("slick-initialized")) {
    $slider.slick("unslick");
  }

  /* ------------------------------------------
     3) Re-init AFTER HTML replacement is done
  -------------------------------------------*/
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const newSlider = document.querySelector(
        `[data-section="${sectionId}"] .product-slideshow__items`
      );

      if (!newSlider) {
        console.warn("⚠ New slider not found");
        return;
      }

      const $newSlider = $(newSlider);

      /* ------------------------------------------
         4) INIT SLICK CLEANLY
      -------------------------------------------*/
      $newSlider.slick({
        dots: true,
        arrows: true,
        prevArrow: $(".slick-prev"),
        nextArrow: $(".slick-next"),
        infinite: true,
        speed: 350,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        mobileFirst: true,
        swipeToSlide: true,
        lazyLoad: "ondemand",
      });

      /* ------------------------------------------
         5) Fade in new slider (NO FLICKER)
      -------------------------------------------*/
      setTimeout(() => {
        newSlider.style.transition = "opacity .25s ease";
        newSlider.style.opacity = "1";

        // Remove height lock
        newSlider.style.minHeight = "0";
      }, 50);
    });
  });
}



/* ============================================================
   3) SYNC RADIO BUTTONS (mobile + desktop)
============================================================ */
function syncRadios(sectionId, variant) {
  if (!variant || !variant.options) return;

  const variantOptions = variant.options;

  const allPickers = document.querySelectorAll(
    `sht-variant-radios[data-section="${sectionId}"],
     sht-variant-radios[data-section="${sectionId}-desktop"]`
  );

  allPickers.forEach((picker) => {
    variantOptions.forEach((optValue, optIndex) => {
      const selector = `.js-variant-radio-item[data-variant-value="${CSS.escape(
        optValue
      )}-${optIndex}"]`;

      const radio = picker.querySelector(selector);
      if (!radio) return;

      radio.checked = true;

      const wrapper = radio.closest(".js-variant-option-value");
      if (!wrapper) return;

      wrapper
        .closest("fieldset")
        ?.querySelectorAll(".js-variant-option-value")
        .forEach((el) => el.classList.remove("is-selected"));

      wrapper.classList.add("is-selected");
    });
  });
}


/* ============================================================
   4–7) MIRROR PRICE / SOLD-OUT BUTTONS (unchanged)
============================================================ */

function mirrorToDesktop(sectionId) {
  safeCopy(`#productPrice-${sectionId}`, `#productPrice-${sectionId}-desktop`);
  safeCopy(
    `#inventoryTracking-${sectionId}`,
    `#inventoryTracking-${sectionId}-desktop`
  );
  safeCopy(`#sku-${sectionId}`, `#sku-${sectionId}-desktop`);
}

function mirrorToMobile(sectionId) {
  safeCopy(`#productPrice-${sectionId}-desktop`, `#productPrice-${sectionId}`);
  safeCopy(
    `#inventoryTracking-${sectionId}-desktop`,
    `#inventoryTracking-${sectionId}`
  );
  safeCopy(`#sku-${sectionId}-desktop`, `#sku-${sectionId}`);
}

function safeCopy(fromSel, toSel) {
  const forbidden = [
    "product-slideshow",
    "sht-prd-slideshow",
    "slick",
    "swiper",
    "js-carousel-items"
  ];
  if (forbidden.some(f => fromSel.includes(f) || toSel.includes(f))) return;

  const from = document.querySelector(fromSel);
  const to = document.querySelector(toSel);
  if (from && to) to.innerHTML = from.innerHTML;
}

function handleSoldoutState(sectionId, isSoldOut) {

  /* -----------------------------
     DESKTOP MAIN FORM
  ------------------------------ */
  const desktopForm = document.querySelector(
    `[data-section-id="${sectionId}-desktop"] .js-product-form-submit-btn`
  );

  /* -----------------------------
     MOBILE MAIN FORM (theme native)
  ------------------------------ */
  const mobileForm = document.querySelector(
    `#productForm-${sectionId} .js-product-form-submit-btn`
  );

  /* -----------------------------
     DESKTOP STICKY FORM
  ------------------------------ */
  const stickyForm = document.querySelector(
    `#productStickyForm-${sectionId} .js-product-form-submit-btn`
  );

  // Update all forms
  updateButtonState(desktopForm, isSoldOut);
  updateButtonState(mobileForm, isSoldOut);
  updateButtonState(stickyForm, isSoldOut);

  // Custom sticky ATC button
  updateExtraStickyButton(isSoldOut);
}


function updateButtonState(btn, isSoldOut) {
  if (!btn) return;
  const label = btn.querySelector(".js-product-form-submit-btn-text");
  btn.disabled = isSoldOut;
  if (label) label.textContent = isSoldOut ? "Sold Out" : "Add to cart";
}

function updateExtraStickyButton(isSoldOut) {
  const btn = document.querySelector(".sticky-atc-btn");
  if (!btn) return;
  btn.disabled = isSoldOut;
  btn.classList.toggle("disabled", isSoldOut);
  btn.textContent = isSoldOut ? "Sold Out" : "Add to cart";
}
